import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UserPhoneNumberUpdateModalUI from './UserPhoneNumberUpdateModalUI'

class UserPhoneNumberUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      phoneNumber: props.selectedUser && props.selectedUser.phoneNumber ? props.selectedUser.phoneNumber : '',
      phoneNumberError: null,
    }
  }

  render() {
    return (
      <UserPhoneNumberUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(event) => { this.setState({ phoneNumber: event.target.value }) }}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => { this.setState({ phoneNumberError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedUser !== this.props.selectedUser) {
      this.setState({
        phoneNumber: this.props.selectedUser && this.props.selectedUser.phoneNumber ? this.props.selectedUser.phoneNumber : ''
      });
    }
  }


  onSubmit = () => {
    if (this.state.submitted) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(
      this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/user/${this.props.selectedUserId}/phoneNumber`,
      this.onSubmitCallback,
      {
        phoneNumber: this.state.phoneNumber
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList) {
      response.errorList.forEach(error => errorList.push(error.message))
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList })
  }
}

export default UserPhoneNumberUpdateModalSF
